import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'app/components/ui/alert-dialog';
import { Button } from 'app/components/ui/button';

import { useEffect } from 'react';
import { useToast } from 'app/components/ui/use-toast';
import { useBlogsSlice } from '../../slice';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}
export function AlertTagsDelete({ isOpen, onOpenChange, data }: Props) {
  const { useDeleteTagsMutation } = useBlogsSlice();

  const { toast } = useToast();

  const [deleteTeam, { isLoading: isDeleting, error: deleteError, isSuccess }] =
    useDeleteTagsMutation();

  const handleDelete = () => {
    deleteTeam(data.tag_id);
  };

  useEffect(() => {
    if (deleteError) {
      toast({
        title: 'Error',
        description: deleteError?.data?.message,
        variant: 'destructive',
      });
    }
  }, [deleteError]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        title: 'Success',
        description: 'Tags deleted successfully',
      });
      onOpenChange(false);
    }
  }, [isSuccess]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete your
            account and remove your data from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
